import React, { useEffect } from "react"
import { useParams } from "react-router-dom"
import axios, { AxiosError, AxiosResponse, HttpStatusCode } from "axios"
import { notification } from 'antd'

import { apiUrl, certificatesUrl } from '../../globals'

const GetCertificate = () => { // TODO: i18n
  const examId = useParams().examId

  useEffect(() => {
    getCertificateByUuid()
  }, [])

  const getCertificateByUuid = async () => {
    try {
      const linkInformationResponse: AxiosResponse<GetCertificateResponse> = await axios.get(`${apiUrl}/get-certificate/${examId}`)
      const { examAttemptYear, examAttemptMonth, examAttemptId } = linkInformationResponse.data

      const downloadLink = `${certificatesUrl}/${examAttemptYear}/${examAttemptMonth}/${examAttemptId}/Certificate.pdf`

      window.location.href = downloadLink
    } catch (err) {
      if (err instanceof AxiosError && err.response?.status === HttpStatusCode.BadRequest) {
        notification.error({
          message: 'Fehler',
          description: 'Das Zertifikat konnte nicht heruntergeladen werden.',
          placement: 'bottomRight',
        })
      }
    }
  }

  return (
    <>
    </>
  )
}

export default GetCertificate

type GetCertificateResponse = {
  examAttemptYear: number
  examAttemptMonth: number
  examAttemptId: string
}